import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import MarqueRequis from '../../Components/Form/MarqueRequis.jsx';
import ButtonDeBase from '../../Components/ButtonsCustom.jsx';

const Etape3Referent = ({ formData, setFormData, onPrevious, ajouterOrganisme, onCpHorsPacaEtAjoutAntenneAvecCpEnPaca,  onCpHorsPacaEtAjoutLieu }) => {
  //const [emailConfimationVal, setEmailConfimationVal] = useState("");
  const [showModalQuestionAntenne, setShowModalQuestionAntenne] = useState(false);
  const handleCloseModalQuestionAntenne = () => setShowModalQuestionAntenne(false);

  function checkAllRight() {
    var pb = 0;
    if (formData.ResponsableNom === '' || formData.ResponsablePrenom === '' || formData.ResponsableMail === '') {
      alert("Veuillez remplir tous les champs obligatoires.");  
      pb = 1;
    }
    
    if (pb == 0 && formData.ResponsableTelFixe === '' && formData.ResponsableTelPortable === '') {
      alert("Veuillez renseigner au moins un numéro de téléphone.");  
      pb = 1;
    }
    else if (formData.ResponsableMail != formData.ResponsableMailConfirm) { // formData.ResponsableMail != emailConfimationVal
      alert("Les e-mails saisis ne correspondent pas.");  
      pb = 1;
    }
    else if (formData.ResponsableMail !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.ResponsableMail)) {
      alert("Veuillez entrer une adresse email valide.");
      pb = 1;
    }

    if(pb == 0) {      
      if (formData.EstEnPaca == 1) { // si dep de paca 
        ajouterOrganisme();
      }
      else { // si dep hors paca 
        if (formData.EstCfa == 0) { 
          onCpHorsPacaEtAjoutAntenneAvecCpEnPaca(); // si ce n'est pas un cfa il doit resiegné un nouvel of EN PACA
        }
        else
          setShowModalQuestionAntenne(true)
      }
    }
  }

  // Pour test, on renseigne les champs obligatoires
  function renseigneToutPourTest() {    
    setFormData({      ...formData,
      ResponsableNom: "responsable nom",
      ResponsablePrenom: "responsable prenom",
      ResponsableMail: "mail.responsable@free.fr",
      ResponsableMailConfirm: "mail.responsable@free.fr",
      ResponsableTelFixe: "06 85 89 98 78",
      ResponsableTelPortable: "06 85 89 98 79",
    });
  }


  return (
    <div>
        {showModalQuestionAntenne &&
        <Modal size="lg" show={showModalQuestionAntenne} onHide={handleCloseModalQuestionAntenne} backdrop="static" keyboard={false} centered aria-labelledby="m1">
            <Modal.Header closeButton>
            <Modal.Title id="m1">
                Avant de passer à l'étape suivante...
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>                
            <div className="bloc-centre">
              <p style={{paddingTop: "20px", fontWeight: "bold"}}>Avez-vous une ou des antennes avec un SIRET différent de votre organisme responsable en Provence-Alpes-Côte d'Azur déclarée(s) auprès de Kairos (France Travail) ? </p>

              <div>
                <ButtonDeBase typeSubmit={false} onClick={onCpHorsPacaEtAjoutAntenneAvecCpEnPaca} lib="Oui" className2="myside2" className="" />
                &nbsp;&nbsp;&nbsp;                
                <ButtonDeBase typeSubmit={false} onClick={onCpHorsPacaEtAjoutLieu} lib="Non" className2="myside2" className=""  />
              </div>
            </div>
            </Modal.Body>
        </Modal>
        }
        
      {global.config.modeDebugAppDisplayInfosSupp == 1 && <div className='debug'>Etape3Referent</div>}
      <h3>Veuillez saisir les informations sur la personne responsable de l'organisme :</h3>
  
      <ButtonDeBase typeSubmit={true} onClick={renseigneToutPourTest} lib="test : tout renseigner" className2="myside2" className=""/><br />
      <p style={{paddingTop: "20px", fontWeight: "bold"}}>Merci de renseigner les informations suivantes :</p>
      <input
        type="text"
        placeholder="Nom"
        value={formData.ResponsableNom}
        onChange={(e) => setFormData({ ...formData, ResponsableNom: e.target.value })}
        className="form-control form-input-lg-short"
        style={{ width: "200px", margin: 10, display: "inline"}}
      /><MarqueRequis />
      <input
        type="text"
        placeholder="Prénom"
        value={formData.ResponsablePrenom}
        onChange={(e) => setFormData({ ...formData, ResponsablePrenom: e.target.value })}
        className="form-control form-input-lg-short"
        style={{ width: "200px", margin: 10, display: "inline"}}
      /><MarqueRequis />
      <br />
      
      <input
        type="email"
        placeholder="Email"
        value={formData.ResponsableMail}
        onChange={(e) => setFormData({ ...formData, ResponsableMail: e.target.value })}
        className="form-control form-input-lg-short"
        style={{ width: "300px", margin: 10, display: "inline"}}
      /><MarqueRequis />

      {/*onChange={(e) => setEmailConfimationVal(e.target.value )} marchait sauf pour le pré remplissage*/}
      <input
        type="email"
        placeholder="Email (confirmation)"
        value={formData.ResponsableMailConfirm}
        onChange={(e) => setFormData({ ...formData, ResponsableMailConfirm: e.target.value })}
        className="form-control form-input-lg-short"
        style={{ width: "300px", margin: 10, display: "inline"}}
      /><MarqueRequis />
      <br />
      
      <input
        type="text"
        placeholder="Téléphone fixe"
        value={formData.ResponsableTelFixe}
        onChange={(e) => setFormData({ ...formData, ResponsableTelFixe: e.target.value })}
        className="form-control form-input-lg-short"
        style={{ width: "200px", margin: 10, display: "inline"}}
      />
      <input
        type="text"
        placeholder="Téléphone portable"
        value={formData.ResponsableTelPortable}
        onChange={(e) => setFormData({ ...formData, ResponsableTelPortable: e.target.value })}
        className="form-control form-input-lg-short"
        style={{ width: "200px", margin: 10, display: "inline"}}
      />


      <br />
      <div><span className="text-obligatoire">Les champs signalés d'un astérisque rouge * sont obligatoires.</span></div>
      <div className="partie-bouton-droite">
        <ButtonDeBase typeSubmit={false} onClick={onPrevious} lib="Étape précédente" className2="myside2" className="" />
        &nbsp;&nbsp;&nbsp;                
        <ButtonDeBase typeSubmit={true}  onClick={checkAllRight} lib="Étape suivante" />
      </div>
    </div>
  );
};

export default Etape3Referent;
